import './App.css';
// CSS for visualization
import '@joint/plus/joint-plus.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toast-overrides.css';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import router from './routes';
import { useQueryClient } from '@tanstack/react-query';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

function App() {
  const queryClient = useQueryClient();
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <RouterProvider router={router(queryClient)} />
        <ToastContainer
          position="top-right"
          autoClose={4000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss={false}
          pauseOnHover
          draggable={true}
          theme="light"
        />
      </LocalizationProvider>
    </>
  );
}

export default App;
